import { RenderControl } from '@fareye/ui'
import React from 'react'
import { TimeZoneProvider, useMapper } from '@fareye/common'
import { ITripDetailsMapper } from '../../utility/types'
import ParcelDetails from './ParcelDetail'
import version from '../../config/npmVersions'

//NOTE: This config is used to render this Route Listing we will move this to server.

export default function MultiModelHistoryMapper(props: ITripDetailsMapper) {
  const [apiData, _] = useMapper({ ...props, version })

  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <ParcelDetails {...props} config={apiData.data as any} />
      </RenderControl>
    </TimeZoneProvider>
  )
}
